import { Injectable, inject } from '@angular/core';
import { DistributionGroup, DistributionGroupLender, PaymentRoute } from '@shared/models';
import { ClubHubDataService } from '@shared/services/clubhub-data.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DistributionGroupsService {
  private readonly clubHubDataService = inject(ClubHubDataService);

  public getDistributionGroups(): Observable<DistributionGroup[]> {
    return this.clubHubDataService.get('DistributionGroup/distributionGroupsByFrn');
  }

  public getDistributionGroupsPaymentRoutes(): Observable<PaymentRoute[]> {
    return this.clubHubDataService.get<PaymentRoute[]>('DistributionGroup/multipleDistributionGroupsPaymentRoutes');
  }

  public getDistributionGroupsLenders(): Observable<DistributionGroupLender[]> {
    return this.clubHubDataService.get<DistributionGroupLender[]>('DistributionGroup/multipleDistributionGroupsLenders');
  }

  public isDistributionGroupEnabled(): Observable<{ enabled: boolean }> {
    return this.clubHubDataService.get('DistributionGroup/enabled');
  }
}
